import mixpanel from 'mixpanel-browser';
import { createAction, handleActions } from 'redux-actions';
import Agent from '../api/Agent';
import { setIsAdminMimicing, setUnauthorizedStatus, setUser } from './user';
import history from '../config/history';
import { fetchOldRequests, fetchPendingRequests } from './admin/requests';
import {
	resetSuperDashboard,
	setSwitchBackToAdminLoading,
	setuserinfo,
	userInfo
} from './supervisor/supervisordashboard';
import { resetSuperShiftList } from './supervisor/supervisorshiftlist';
import { resetShiftList } from './admin/shiftIndex';
import { resetAdminTimesheetDetailVal } from './admin/timesheetdetail';
import { resetNurseTimesheetDetail } from './checkout';
import { resetSuperTimesheetDetailVal } from './supervisor/supervisortimesheetdetail';
import { resetRequirementVal } from './admin/requirement';
import { setUserPreferences } from './account';
import { notification } from './nurseshift';
import { getDNRReason } from './supervisor/supervisorshiftdetails';

import mixpanelConstants from '../constants/mixpanel';
import { fetchAccountContact } from './nurse/account';
import { removeTokenFromCookies, setTokenInCookies } from '../utils/cookie';
import { getRoles } from './resources';

import { getImpersonateUserToken } from '../api/supervisor';
import { setIsImpersonatingLoadingStatus } from './admin/userIndex';
import { clearSupervisorScheduleData } from './supervisor/supervisorSchedule';
import { clearLocalStorage } from '../utils/user';
import { queryClient } from '/client/queryClient';
import { getGetUserScopesQueryKey } from '/client/apiserv';

export const setLoginEmail = createAction('SET_LOGIN_EMAIL');
export const setLoginPassword = createAction('SET_LOGIN_PASSWORD');
export const setLoginDisplay = createAction('SET_LOGIN_DISPLAY');
export const setLoginMessage = createAction('SET_LOGIN_MESSAGE');
export const setNewUser = createAction('SET_NEW_USER');
export const setUserID = createAction('SET_USER_ID');
export const setUpdatePass = createAction('SET_UPDATE_PASSWORD');
export const setLoggedIn = createAction('SET_LOGGED_IN');
export const resetLogin = createAction('RESET_LOGIN');
export const setPage = createAction('SET_PAGE');
export const setToken = createAction('SET_TOKEN');
export const setMimicToken = createAction('SET_MIMIC_TOKEN');
export const SetLoggedInAsSupervisor = createAction('SET_LOGGED_IN_AS_SUPERVISOR');
export const SetLoggedInAsAdmin = createAction('SET_LOGGED_IN_AS_ADMIN');
export const SetIsSubmitted = createAction('SET_IS_SUBMITTED');
export const setIsSignupHide = createAction('SET_IS_SIGNUP_HIDE');
export const setAdminRejectReasonStatus = createAction('SET_ADMIN_REJECT_REASON_STATUS');
export const setIsRedirectToFountain = createAction('SET_IS_REDIRECTTOFOUNTAIN');
export const setCICOIterations = createAction('SET_CICO_ITERATIONS');
export const setSupervisorDateColumn = createAction('SET_SUPERVISOR_DATE_COLUMN');
export const setQRDetails = createAction('SET_QR_DETAILS');

const initialState = {
	cicoIterations: false,
	display: 'none',
	email: '',
	is_admin_reject_reason_enable: false,
	isRedirectToFountain: false,
	issignupHide: false,
	isSumbitted: false,
	loggedin: false,
	loggedinAsAdmin: false,
	loggedinAsSupervisor: false,
	message: '',
	mimicToken: '',
	newUser: false,
	page: '/',
	password: '',
	supervisorDateColumn: false,
	token: '',
	updatePassword: false,
	userId: 0
};

export default handleActions(
	{
		RESET_LOGIN: () => initialState,
		SET_ADMIN_REJECT_REASON_STATUS: (state, action) => ({ ...state, is_admin_reject_reason_enable: action.payload }),
		SET_CICO_ITERATIONS: (state, action) => ({ ...state, cicoIterations: action.payload }),
		SET_IS_REDIRECTTOFOUNTAIN: (state, action) => ({ ...state, isRedirectToFountain: action.payload }),
		SET_IS_SIGNUP_HIDE: (state, action) => ({ ...state, isSignupHide: action.payload }),
		SET_IS_SUBMITTED: (state, action) => ({ ...state, isSumbitted: action.payload }),
		SET_LOGGED_IN: (state, action) => ({ ...state, loggedin: action.payload }),
		SET_LOGGED_IN_AS_ADMIN: (state, action) => ({ ...state, loggedinAsAdmin: action.payload }),
		SET_LOGGED_IN_AS_SUPERVISOR: (state, action) => ({ ...state, loggedinAsSupervisor: action.payload }),
		SET_LOGIN_DISPLAY: (state, action) => ({ ...state, display: action.payload }),
		SET_LOGIN_EMAIL: (state, action) => ({ ...state, email: action.payload }),
		SET_LOGIN_MESSAGE: (state, action) => ({ ...state, message: action.payload }),
		SET_LOGIN_PASSWORD: (state, action) => ({ ...state, password: action.payload }),
		SET_LOGIN_REDIRECT: (state, action) => ({ ...state, redirect: action.payload }),
		SET_MIMIC_TOKEN: (state, action) => ({ ...state, mimicToken: action.payload }),
		SET_NEW_USER: (state, action) => ({ ...state, newUser: action.payload }),
		SET_PAGE: (state, action) => ({ ...state, page: action.payload }),
		SET_QR_DETAILS: (state, action) => ({ ...state, qrDetails: action.payload }),
		SET_REDIRECT_BACK_TO: (state, action) => ({ ...state, redirectBackTo: action.payload }),
		SET_SUPERVISOR_DATE_COLUMN: (state, action) => ({ ...state, supervisorDateColumn: action.payload }),
		SET_TOKEN: (state, action) => ({ ...state, token: action.payload }),
		SET_UPDATE_PASSWORD: (state, action) => ({ ...state, updatePassword: action.payload }),
		SET_USER_ID: (state, action) => ({ ...state, userId: action.payload })
	},
	initialState
);

export const login = () => async (dispatch, getState) => {
	const { email, password } = getState().login;

	if (email === '' || password === '') {
		dispatch(setLoginMessage('Fill all the fields'));
		return;
	}

	localStorage.setItem('login-event', `login${Math.random()}`);

	const response = await Agent.login(email, password);
	if (response.ok) {
		if (response.data.suspended) {
			dispatch(setLoginDisplay('block'));
			dispatch(setLoginMessage('Your account has been suspended. Please contact ConnectRN Support.'));
			dispatch(SetIsSubmitted(false));
			return 'Your account has been suspended. Please contact ConnectRN Support.';
		}
		if (response.data.activated === false && response.data.status === 'inactive') {
			dispatch(setLoginDisplay('block'));
			dispatch(setLoginMessage('Your account has been set inactive. Please contact ConnectRN Support.'));
			dispatch(SetIsSubmitted(false));
			return 'Your account has been set inactive. Please contact ConnectRN Support.';
		}
		const userId = response.data.id;

		dispatch(setIsAdminMimicing(response.data.is_mimic));
		dispatch(setMimicToken(response.data.is_mimic ? response.data.token : ''));

		if (response.data.update_password && response.data.admin) {
			dispatch(setUpdatePass(true));
			dispatch(setUserID(userId));
			return 'update password';
		}

		if (response.data.last_activity === null && response.data.update_password) {
			dispatch(setNewUser(true));
			dispatch(setUserID(userId));
			return 'new user';
		}

		if (response.data.nurse) {
			localStorage.setItem('token', response.data.token);
			localStorage.setItem('role', 'nurse');
			dispatch(setToken(response.data.token));
			dispatch(setUser(response.data));
			dispatch(setLoggedIn(true));
			dispatch(setLoginDisplay('none'));
			dispatch(setLoginMessage(''));
			if (!response.data.is_registration_completed) {
				setSignUpFeature(dispatch);
			}
			dispatch(fetchAccountContact());
			trackSignInComplete(response.data, 'nurse', userId);
			history.push(response.data.reset_password === true ? 'resetpassword' : 'nurse/shifts/accepted');
			dispatch(notification());
		}
		if (response.data.supervisor) {
			localStorage.setItem('token', response.data.token);
			localStorage.setItem('role', 'supervisor');
			localStorage.setItem('shift_manager', (!!response.data.shift_manager).toString());
			localStorage.setItem('firstLogin', 1);
			dispatch(
				setQRDetails({
					orgId: response.data.user_orgs[0].organization_id,
					timezone_name: response.data.user_orgs[0].timezone_name
				})
			);
			dispatch(setToken(response.data.token));
			dispatch(userInfo());
			dispatch(setUser(response.data));
			dispatch(setuserinfo(response.data));
			dispatch(setSupervisorDateColumn(response.data.supervisor_date_column));
			dispatch(SetLoggedInAsSupervisor(true));
			dispatch(setLoggedIn(true));
			dispatch(setLoginDisplay('none'));
			dispatch(setLoginMessage(''));
			dispatch(getDNRReason());
			trackSignInComplete(response.data, 'supervisor', userId);
			if (!response.data.shift_manager) {
				dispatch(notification());
			}
			history.push(response.data.reset_password ? 'resetpassword' : '/supervisor/dashboard');
		} else if (response.data.admin) {
			localStorage.setItem('token', response.data?.token);
			localStorage.setItem('admin_token', response.data?.token);
			localStorage.setItem('role', 'admin');
			dispatch(setToken(response.data.token));
			dispatch(setUser(response.data));
			dispatch(SetLoggedInAsAdmin(true));
			dispatch(setLoggedIn(true));
			dispatch(setLoginDisplay('none'));
			dispatch(setLoginMessage(''));
			dispatch(fetchPendingRequests());
			dispatch(fetchOldRequests());

			trackSignInComplete(response.data, 'admin', userId);
			history.push(response.data.reset_password === true ? 'resetpassword' : 'admin');
		}

		dispatch(setUnauthorizedStatus(false));
		dispatch(SetIsSubmitted(true));
		dispatch(getRoles());

		// Set token in cookies
		setTokenInCookies(response.data.token);
	} else {
		dispatch(setLoginMessage(response.data));
		dispatch(setLoginDisplay('block'));
		dispatch(SetIsSubmitted(false));
	}

	dispatch(setAdminRejectReasonStatus(response.data.admin_req_reject_reasons));
	return response;
};

function trackSignInComplete(userInfo, role, userId) {
	registerMixpanelProperties(userInfo, role, userId);
	mixpanel.track(mixpanelConstants.SIGN_IN_COMPLETE);
}

export const registerMixpanelProperties = (userInfo, role) => {
	const isTestUser = userInfo.is_test_user ? 1 : 0;

	mixpanel.register({
		Email: userInfo.email,
		'First Name': userInfo.first_name,
		Is_Test_User: isTestUser,
		'Last Name': userInfo.last_name,
		role
	});
};

export const logout = () => (dispatch) => {
	dispatch(resetLogin());
	dispatch(resetSuperDashboard());
	dispatch(resetShiftList());
	dispatch(resetSuperShiftList());
	dispatch(resetAdminTimesheetDetailVal());
	dispatch(resetNurseTimesheetDetail());
	dispatch(resetSuperTimesheetDetailVal());
	dispatch(resetRequirementVal());
	dispatch(setUserPreferences({}));
	dispatch(setUnauthorizedStatus(false));
	clearLocalStorage();
	localStorage.setItem('logout-event', `logout${Math.random()}`);
	mixpanel.reset();
	setPage('/');

	// remove token from cookies
	removeTokenFromCookies();
};

export const getIsRedirectToFountain = () =>
	function (dispatch) {
		Agent.getIsRedirectToFountain().then((response) => {
			if (response != null && response.data != null) {
				if (response.data.is_redirecttofountain != undefined) {
					dispatch(setIsRedirectToFountain(response.data.is_redirecttofountain));
				}
			}
		});
	};

const resetAndSetTokenInCookie = (newToken) => {
	removeTokenFromCookies();
	setTokenInCookies(newToken);
};

export const impersonateSupervisorStart = (supervisorId) => async (dispatch, getState) => {
	dispatch(setIsImpersonatingLoadingStatus(true));
	try {
		const { user } = getState();
		const { fullname: adminFullName } = user;
		const res = await getImpersonateUserToken(supervisorId);
		// If we have scopes from the response, set them, otherwise re-fetch
		if (res?.data?.scopes) {
			queryClient.setQueryData(getGetUserScopesQueryKey(), res?.data?.scopes);
		} else {
			queryClient.invalidateQueries({ queryKey: getGetUserScopesQueryKey() });
		}
		const supervisorInfo = res.data;
		localStorage.setItem('impersonate', true);
		localStorage.setItem('token', supervisorInfo.token);
		localStorage.setItem('role', 'supervisor');
		localStorage.setItem('shift_manager', (!!res.data.shift_manager).toString());
		mixpanel.track(mixpanelConstants.START_IMPERSONATING_SUPERVISOR, {
			admin: adminFullName,
			supervisor: supervisorInfo.fullname
		});
		// Set mixpanel identity to supervisor
		registerMixpanelProperties(supervisorInfo, 'supervisor', supervisorInfo.id);
		resetAndSetTokenInCookie(supervisorInfo.token);
		dispatch(setuserinfo(supervisorInfo));
		dispatch(setSupervisorDateColumn(supervisorInfo.supervisor_date_column));
		dispatch(getDNRReason());
		if (!res.data.shift_manager) {
			dispatch(notification());
		}
		history.push('/supervisor/dashboard');
	} catch (err) {
		alert(response?.data?.message ?? 'Something went wrong');
	}

	dispatch(setUnauthorizedStatus(false));
	dispatch(getRoles());
	dispatch(setIsImpersonatingLoadingStatus(false));
};

export const impersonateSupervisorStop = () => async (dispatch, getState) => {
	const state = getState();
	const { fullname: SupervisorFullName } = state.user;
	const adminToken = localStorage.getItem('admin_token');
	localStorage.removeItem('impersonate');
	localStorage.setItem('token', adminToken);
	localStorage.setItem('role', 'admin');
	dispatch(clearSupervisorScheduleData());
	dispatch(setSwitchBackToAdminLoading(true));

	try {
		const res = await Agent.userinfo();
		const adminInfo = res.data;
		resetAndSetTokenInCookie(adminToken);
		mixpanel.track(mixpanelConstants.STOP_IMPERSONATING_SUPERVISOR, {
			admin: adminInfo.fullname,
			supervisor: SupervisorFullName
		});
		// Set mixpanel identity to admin
		registerMixpanelProperties(adminInfo, 'admin', adminInfo.id);
		dispatch(setUser(adminInfo));
		dispatch(fetchPendingRequests());
		dispatch(fetchOldRequests());
		queryClient.invalidateQueries(getGetUserScopesQueryKey());
		history.push('/admin');
	} catch (err) {
		alert(response?.data?.message ?? 'Something went wrong');
	}

	dispatch(setUnauthorizedStatus(false));
	dispatch(getRoles());
	dispatch(setSwitchBackToAdminLoading(false));
};
